<template>
  <div class="container-fluid px-4 mt-4">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h5 class="fw-bold mb-0">할인 관리</h5>
      <button class="btn btn-primary btn-sm" @click="openAdd">+ 할인 등록</button>
    </div>

    <div v-if="loadError" class="alert alert-danger">{{ loadError }}</div>
    <div v-if="loading" class="text-center py-5 text-muted">불러오는 중...</div>

    <table v-else class="table table-hover align-middle">
      <thead class="table-dark">
        <tr>
          <th>#</th>
          <th>할인명</th>
          <th class="text-end">할인율(%)</th>
          <th class="text-center">관리</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="discounts.length === 0">
          <td colspan="4" class="text-center text-muted py-4">등록된 할인이 없습니다.</td>
        </tr>
        <tr v-for="d in discounts" :key="d.DiscountSeq">
          <td class="text-muted small">{{ d.DiscountSeq }}</td>
          <td>{{ d.DiscountName }}</td>
          <td class="text-end">{{ d.DiscountRate }}%</td>
          <td class="text-center">
            <button class="btn btn-sm btn-outline-primary me-1" @click="openEdit(d)">수정</button>
            <button class="btn btn-sm btn-outline-danger" @click="confirmDelete(d)">삭제</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 등록/수정 모달 -->
    <div v-if="formModal" class="modal-backdrop-custom">
      <div class="modal-box" @click.stop>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="fw-bold mb-0">{{ isEdit ? '할인 수정' : '할인 등록' }}</h6>
          <button class="btn-close" @click="formModal = false"></button>
        </div>

        <div class="mb-2">
          <label class="form-label form-label-sm">할인명 <span class="text-danger">*</span></label>
          <input v-model="form.DiscountName" type="text" class="form-control form-control-sm" maxlength="100" />
        </div>
        <div class="mb-3">
          <label class="form-label form-label-sm">할인율(%) <span class="text-danger">*</span></label>
          <input v-model.number="form.DiscountRate" type="number" class="form-control form-control-sm" min="0" max="100" />
        </div>

        <div v-if="formError" class="alert alert-danger py-1 small">{{ formError }}</div>

        <div class="d-flex gap-2 justify-content-end">
          <button class="btn btn-secondary btn-sm" @click="formModal = false">취소</button>
          <button class="btn btn-primary btn-sm" :disabled="saving" @click="saveForm">{{ saving ? '저장 중...' : '저장' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const emptyForm = () => ({ DiscountSeq: null, DiscountName: '', DiscountRate: null })

export default {
  name: 'AdminDiscountView',
  data() {
    return {
      discounts: [],
      loading: false,
      loadError: null,
      formModal: false,
      isEdit: false,
      form: emptyForm(),
      formError: null,
      saving: false
    }
  },
  mounted() {
    this.fetchDiscounts()
  },
  methods: {
    async fetchDiscounts() {
      this.loading = true
      this.loadError = null
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_BASE}/api/admin/discount`)
        this.discounts = res.data
      } catch (e) {
        this.loadError = '할인 목록을 불러오지 못했습니다.'
      } finally {
        this.loading = false
      }
    },
    openAdd() {
      this.isEdit = false
      this.form = emptyForm()
      this.formError = null
      this.formModal = true
    },
    openEdit(d) {
      this.isEdit = true
      this.form = { ...d }
      this.formError = null
      this.formModal = true
    },
    async saveForm() {
      const { DiscountSeq, DiscountName, DiscountRate } = this.form
      if (!DiscountName || DiscountRate == null) {
        this.formError = '할인명과 할인율은 필수입니다.'
        return
      }
      if (DiscountRate < 0 || DiscountRate > 100) {
        this.formError = '할인율은 0~100 사이여야 합니다.'
        return
      }
      this.saving = true
      try {
        if (this.isEdit) {
          await axios.put(`${process.env.VUE_APP_API_BASE}/api/admin/discount/${DiscountSeq}`, { discountName: DiscountName, discountRate: DiscountRate })
        } else {
          await axios.post(`${process.env.VUE_APP_API_BASE}/api/admin/discount`, { discountName: DiscountName, discountRate: DiscountRate })
        }
        this.formModal = false
        await this.fetchDiscounts()
      } catch (e) {
        this.formError = e.response?.data?.message || '저장에 실패했습니다.'
      } finally {
        this.saving = false
      }
    },
    confirmDelete(d) {
      if (!confirm(`할인 "${d.DiscountName}"을(를) 삭제하시겠습니까?`)) return
      this.doDelete(d)
    },
    async doDelete(d) {
      try {
        await axios.delete(`${process.env.VUE_APP_API_BASE}/api/admin/discount/${d.DiscountSeq}`)
        await this.fetchDiscounts()
      } catch (e) {
        alert(e.response?.data?.message || '삭제에 실패했습니다.')
      }
    }
  }
}
</script>

<style scoped>
.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-box {
  background: #fff;
  border-radius: 10px;
  padding: 1.5rem;
  width: 420px;
  max-width: 95vw;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
}
</style>
